import CategoryGrid from 'features/rewards/components/CategoryGrid/CategoryGrid';
import DynamicMapCard from 'features/rewards/components/MapCard/DynamicMapCard';
import FeaturedOfferCardCarousel from 'features/rewards/components/rewardsCarousels/FeaturedOfferCardCarousel';
import NearbyOffersCarousel from 'features/rewards/components/rewardsCarousels/NearbyOffersCarousel';
import StandardOfferCardCarousel from 'features/rewards/components/rewardsCarousels/StandardOfferCardCarousel';
import { ReactNode } from 'react';
import ListItemGroup from 'shared/components/vxl/ListItemGroup/ListItemGroup';
import ScrollingButtonGroup from 'shared/containers/vxl/groups/ScrollingButtonGroup/ScrollingButtonGroup';
import SideBySideCardGroup from 'shared/containers/vxl/groups/SideBySideCardGroup/SideBySideCardGroup';
import ComponentGroup from 'shared/renderer/GenericContainers/ComponentGroup';
import { VXLGroupId } from 'shared/renderer/types';

type GroupRegistryType = {
  [key in VXLGroupId]: (props: unknown) => React.JSX.Element | ReactNode;
};

const GroupRegistry: GroupRegistryType = {
  CATEGORY_GRID: CategoryGrid,
  COMPONENT_GROUP: ComponentGroup,
  DYNAMIC_MAP_CARD: DynamicMapCard,
  FEATURED_OFFER_CARD_CAROUSEL: FeaturedOfferCardCarousel,
  LIST_ITEM_GROUP: ListItemGroup,
  NEARBY_OFFERS_CAROUSEL: NearbyOffersCarousel,
  SCROLLING_BUTTON_GROUP: ScrollingButtonGroup,
  SIDE_BY_SIDE_CARD_GROUP: SideBySideCardGroup,
  STANDARD_OFFER_CARD_CAROUSEL: StandardOfferCardCarousel,
};

export default GroupRegistry;
